import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { User } from "oidc-client";
import { AppDispatch, ApplicationState } from '../../store';
import { fetchProfile, saveProfile } from '../../store/Profile';
import { AsyncStatus } from '../../model/common/AsyncStatus';
import CandidateType from '../../model/hros/recruiting/CandidateType';
import { ProfileForm } from '../profile';
import Loading from '../Loading';
import toastHelper from '../../utils/toastHelper';

const Profile = function () {
  const dispatch : AppDispatch = useDispatch();
  const profileFetchStatus = useSelector<ApplicationState, AsyncStatus>(state => state.profile.fetchStatus);
  const profileSaveStatus = useSelector<ApplicationState, AsyncStatus>(state => state.profile.saveStatus);
  const profile = useSelector<ApplicationState, CandidateType | undefined>(state => state.profile.profile);
  const user = useSelector<ApplicationState, User | null>(state => state.user.user);
  
  // Fetch the profile if it hasn't been fetched yet.
  useEffect(() => {
    if (profileFetchStatus === 'idle') {
      dispatch(fetchProfile());
    }
  }, [profileFetchStatus, dispatch]);

  const onSaveProfile = async function(profile: CandidateType, onSuccess: () => void) {
    const resultAction = await dispatch(saveProfile(profile));
    if (saveProfile.fulfilled.match(resultAction)) {
      toastHelper.success("Profile Saved!");
      onSuccess();
    } else if (saveProfile.rejected.match(resultAction)) {
      toastHelper.error("An error has occured while saving.");
    }
  }
  
  let content = undefined;
  if (profileFetchStatus === 'failed') {
    content = <h1>Error loading profile!</h1>;
  }
  else if (profileFetchStatus === 'succeeded') {
    content = <ProfileForm profile={profile} user={user} saveStatus={profileSaveStatus} onSaveProfile={onSaveProfile} />;
  }

  return <Loading isLoading={profileFetchStatus === 'idle' || profileFetchStatus === 'loading'}>
    {content}
  </Loading>;
}

export default Profile;